import React from 'react'
import { Button } from 'react-native-elements'
import PropTypes from 'prop-types'

import Icon from '../Icons'
import { StyleSheet, ViewPropTypes } from 'react-native'
import { useTheme } from '../../theming/ThemeProvider'

export default function IconButton ({ color, iconColor, icon, size, iconSize, style, ...props }) {
  const { theme } = useTheme()
  return (
    <Button
      containerStyle={{
        borderRadius: 100,
        width: size,
        height: size,
        backgroundColor: theme[color] || theme.SECONDARY_BUNKER,
        ...style
      }}
      buttonStyle={[
        styles.button,
        {
          width: size,
          height: size,
          backgroundColor: theme[color] || theme.SECONDARY_BUNKER
        }
      ]}
      icon={
        <Icon
          name={icon}
          width={iconSize}
          height={iconSize}
          fill={theme[iconColor] || theme.WHITE}
        />
      }
      {...props}
    />
  )
}

const styles = StyleSheet.create({
  button: {
    borderRadius: 100
  }
})

IconButton.propTypes = {
  color: PropTypes.string,
  iconColor: PropTypes.string,
  size: PropTypes.number,
  iconSize: PropTypes.number,
  style: ViewPropTypes.style,
  icon: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired
}

IconButton.defaultProps = {
  color: '',
  iconColor: '',
  size: 35,
  iconSize: 16,
  icon: '',
  onPress: () => {}
}
